import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { ReserveAutoAllotementOperation } from "../../../CrudOperations/PostOperation";
import ReserveManulaAllotementModal from "../ReserveManulaAllotementModal";


// Reusable Stat Card Component
const StatCard = ({
  title,
  subtitle,
  subSubTitle,
  colors,
  onClick,
  tag,
  isActive,
}) => (
  <div
    onClick={onClick}
    className={`relative cursor-pointer ${colors} p-5 rounded-xl shadow-md transition 
      ${isActive ? "scale-105 shadow-lg" : ""} 
      hover:scale-105 hover:shadow-lg text-white`}
  >
    {/* Corner Tag */}
    {tag && (
      <div className="absolute top-2 right-2 bg-white text-xs text-gray-800 font-semibold px-2 py-1 rounded-full shadow">
        {tag === "bg-red-500"
          ? "Past"
          : tag === "bg-green-500"
          ? "Current"
          : tag === "bg-blue-500"
          ? "Upcoming"
          : "error"}
      </div>
    )}

    <h3 className="text-xl font-semibold">{subtitle}</h3>
    <h2 className="text-md text-gray-200 font-semibold">{title}</h2>
    <h2 className="text-md text-gray-200 font-semibold">{subSubTitle}</h2>
  </div>
);



const AreaSection = ({  OpenManualAllotement , setOpenManualAllotement , submitForm,    selectedDeputyCheckpointId,  handleView,ReservedDeputy , handleManulAllotement}) => {







  return (
    <div className="bg-gray-50 p-4 rounded-md shadow">
          <div className="flex flex-row justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Reserved Deputies</h2>

            <div className="flex gap-4  rounded-md px-3 text-sm">
              <button
                // onClick={handleView}
                         onClick={() => {
                  toast.warn("Comming Soon... Try Again later")
                }}
                className={`  
                    "flex items-center gap-1 text-xs py-1 px-2 rounded-md border cursor-not-allowed bg-pink-200 hover:bg-pink-200"
                `}
              >
                <FontAwesomeIcon icon={faEye} />
                View
              </button>
              <button
                onClick={() =>  selectedDeputyCheckpointId ?   submitForm("Auto" , selectedDeputyCheckpointId) : toast.warn("Please Select CheckPoint")  }
                // disabled={areas.isAllotted}
                className={`
                "flex items-center gap-1 text-xs bg-blue-200 py-1 px-2 rounded-md border hover:bg-blue-100"
                `}
              >
                <FontAwesomeIcon icon={faPlus} />
                Auto Allotment
              </button>
              {console.log(selectedDeputyCheckpointId)
              }
              <button
                onClick={() => 
                  
                  // handleManulAllotement()

                  selectedDeputyCheckpointId ?   setOpenManualAllotement(true) : toast.warn("Please Select Checkpoint")
                
                }
                className={`flex items-center bg-orange-200 gap-1 text-xs py-1 px-2 rounded-md border cursor-pointer `}
              >
                <FontAwesomeIcon icon={faPlus} />
                Manual Allotment
              </button>
              {/* <button
                onClick={handleDownload}
                className={`  ${
                  areas.isAllotted
                    ? " flex items-center gap-1 text-xs py-1 px-2 rounded-md border  bg-gray-100"
                    : "flex items-center gap-1 text-xs py-1 px-2 rounded-md border cursor-not-allowed hover:bg-blue-100"
                }`}
              >
                <FontAwesomeIcon icon={faDownload} />
                Download Allotment
              </button> */}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            {ReservedDeputy.length > 0 ? (
              ReservedDeputy.map((RD) => (
                <StatCard
                  onClick={() =>
                    navigate(`/${localStorage.getItem("token")}/manageArea`, {
                      state: { areaId: RD.AllottedStaffId },
                    })
                  }
                  key={RD.AllottedStaffId}
                  // title={`No. Of Deputation : ${area.NoOfDeputation}`}
                  subtitle={`${RD.FullName}`}
                  // subSubTitle={`Alloted Deputies : ${area.AllottedCount}`}
                  colors="bg-gradient-to-br from-green-500 to-emerald-600"
                />
              ))
            ) : (
              <p className="text-gray-500">Select CheckPoint.</p>
            )}
          </div>


                {OpenManualAllotement && (
        <ReserveManulaAllotementModal
          ManualAllotementData={selectedDeputyCheckpointId}
          closeModal={() => setOpenManualAllotement(false)}
          // onsubmit={handleManualOnSubmit}
        />
      )}


        </div>
  );
};

export default AreaSection;
